import debounce from 'lodash/debounce';
import { useEffect, useMemo } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useDebounce<T extends (...args: any) => any>(memoizedCallback: T, ms: number) {
    const debouncedFunc = useMemo(() => {
        return debounce(memoizedCallback, ms);
    }, [memoizedCallback, ms]);

    useEffect(() => {
        return () => {
            debouncedFunc.cancel();
        };
    }, [debouncedFunc]);

    return debouncedFunc;
}
